export function isArray(arg: any): arg is Array<any> {
  return Array.isArray(arg);
}
